import {
  // GET PLACE CONTACTS
  GET_PLACE_CONTACTS,
  GET_PLACE_CONTACTS_FAILED,
  GET_PLACE_CONTACTS_SUCCESS,

  // GET PLACE CONTACT DETAILS
  GET_PLACE_CONTACT_DETAILS,
  GET_PLACE_CONTACT_DETAILS_SUCCESS,
  GET_PLACE_CONTACT_DETAILS_FAILED,

  // ADD PLACE CONTACT
  ADD_PLACE_CONTACT,
  ADD_PLACE_CONTACT_FAILED,
  ADD_PLACE_CONTACT_SUCCESS,

  // EDIT PLACE CONTACT
  EDIT_PLACE_CONTACT,
  EDIT_PLACE_CONTACT_SUCCESS,
  EDIT_PLACE_CONTACT_FAILED,

  // DELETE PLACE CONTACT
  DELETE_PLACE_CONTACT,
  DELETE_PLACE_CONTACT_SUCCESS,
  DELETE_PLACE_CONTACT_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetPlaceContacts: false,
  isLoadingGetPlaceContactDetails: false,
  isLoadingAddPlaceContact: false,
  isLoadingEditPlaceContact: false,

  placeContactsList: [],
  placeContactDetails: {},
};

export default function placeContacts(state = initialState, action) {
  switch (action.type) {
    // GET PLACE CONTACTS
    case GET_PLACE_CONTACTS:
      return {
        ...state,
        isLoadingGetPlaceContacts: true,
      };

    case GET_PLACE_CONTACTS_SUCCESS:
      return {
        ...state,
        placeContactsList: action.payload,
        isLoadingGetPlaceContacts: false,
      };

    case GET_PLACE_CONTACTS_FAILED:
      return {
        ...state,
        isLoadingGetPlaceContacts: false,
      };

    // GET PLACE CONTACT DETAILS
    case GET_PLACE_CONTACT_DETAILS:
      return {
        ...state,
        isLoadingGetPlaceContactDetails: true,
      };

    case GET_PLACE_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        placeContactDetails: action.payload,
        isLoadingGetPlaceContactDetails: false,
      };

    case GET_PLACE_CONTACT_DETAILS_FAILED:
      return {
        ...state,
        isLoadingGetPlaceContactDetails: false,
      };

    // ADD PLACE CONTACT
    case ADD_PLACE_CONTACT:
      return {
        ...state,
        isLoadingAddPlaceContact: true,
      };

    case ADD_PLACE_CONTACT_SUCCESS:
      return {
        ...state,
        isLoadingAddPlaceContact: false,
      };

    case ADD_PLACE_CONTACT_FAILED:
      return {
        ...state,
        isLoadingAddPlaceContact: false,
      };

    // EDIT PLACE CONTACT
    case EDIT_PLACE_CONTACT:
      return {
        ...state,
        isLoadingEditPlaceContact: true,
      };

    case EDIT_PLACE_CONTACT_SUCCESS:
      return {
        ...state,
        isLoadingEditPlaceContact: false,
      };

    case EDIT_PLACE_CONTACT_FAILED:
      return {
        ...state,
        isLoadingEditPlaceContact: false,
      };

      // DELETE PLACE CONTACT
    case DELETE_PLACE_CONTACT:
      return {
        ...state,
        isLoadingDeletePlaceContact: true,
      };

    case DELETE_PLACE_CONTACT_SUCCESS:
      return {
        ...state,
        isLoadingDeletePlaceContact: false,
      };

    case DELETE_PLACE_CONTACT_FAILED:
      return {
        ...state,
        isLoadingDeletePlaceContact: false,
      };

    default:
      return state;
  }
}
